import React from 'react';
import { SafeSuspense } from 'utils/SafeSuspense';

const PriceChart = React.lazy(() => import('./chart'));

interface OuterProps {
  innerTitle?: JSX.Element;
  outerTitle?: JSX.Element;
  chartTitle?: JSX.Element;
}

const OuterComponent: React.FC<OuterProps> = ({
  innerTitle,
  outerTitle,
  chartTitle,
}) => (
  <SafeSuspense>
    <PriceChart
      innerTitle={innerTitle}
      outerTitle={outerTitle}
      chartTitle={chartTitle}
    />
  </SafeSuspense>
);

export default OuterComponent;
